import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import MainPageComponents from "../components/CommonComponents/MainPageComponents";

interface FAQSPageItem {
  title: string;
  slug: string;
  content: string;
}

const FAQSPage: React.FC = () => {
  const [faqs, setFaqs] = useState<FAQSPageItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCmsContent("FAQ`S", "/api/cms/faqs", setFaqs, setLoading);
  }, []);


  return (
    <MainPageComponents
      title={faqs?.title || "FAQ`s"}
      content={faqs?.content || ""}
      loading={loading}
      updated_at=""
    />);
};

export default FAQSPage;
